export const apiPaths = {
  login: '/account/login',
  activate: '/account/activate',
  confirmEmail: '/account/confirmEmail',
  forgotPassword: '/account/forgotpassword',
  resetPassword: '/account/resetpassword',
  settings: '/api/settings',
};

export const paths = {
  login: '/account/login',
  activate: '/account/activate',
  confirmEmail: '/account/confirmemail',
  forgotPassword: '/account/forgotpassword',
  resetPassword: '/account/resetpassword',
  qadra: 'https://www.qadra.com',
};
